import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./upsize_upsell_display_style.js";
//#region src/upsize_upsell_display_style_helper.ts
var upsize_upsell_display_style_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(style) {
	switch (style) {
		case "standard": return "Standard";
		case "comparison": return "Comparison";
	}
}
//#endregion
export { name, upsize_upsell_display_style_helper_exports };

//# sourceMappingURL=upsize_upsell_display_style_helper.js.map